export default "__VITE_ASSET__$ykXMJFQ__"